import { FunctionComponent, useMemo } from "react";
import { GameInfoProps } from "../../type";
import { Payout, Rule } from "./type";
import HippoSplashUtils from "./utils";
import "./hippo-splash.scss";

export const HippoSplashRuleView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const {
    payouts = {},
    buyFreeSpinRate = 50,
    givenFreeSpin = {},
  } = data as Rule;
  let payoutsFlat = Object.entries(payouts)
    .map(([key, value]) => [key, Object.values(value)[0]]) 
    .reduce((acc, [key, value]) => {
      acc[key] = value as number;
      return acc;
    }, {} as Payout);
  const candyPayouts = Object.entries(payoutsFlat).sort((a, b) => b[1] - a[1]);
  const halfCandyCount = candyPayouts.length / 2;
  const payoutElement = [
    <tr key={1} className="text-center">
    {candyPayouts.slice(0, halfCandyCount).map(([symbol, payout], i) => (
      <td key={`symbol-${symbol}`}>
        <div className="d-inline-block symbol">
          {HippoSplashUtils.convertSymbol(+symbol)}
        </div>
        <div className="">{payout}</div>
      </td>
    ))}
  </tr>,
    <tr key={2} className="text-center">
      {candyPayouts.slice(halfCandyCount).map(([symbol, payout], i) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {HippoSplashUtils.convertSymbol(+symbol)}
          </div>
          <div className="">{payout}</div>
        </td>
      ))}
    </tr>,
  ];
  const specialSymbols = [
    <tr key={1} className="text-center">
      {[4, 2, 3].map((symbol) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {HippoSplashUtils.convertSymbol(+symbol)}
          </div>
        </td>
      ))}
    </tr>,
  ];
  return (
    <>
      <h5 className="card-title">Description</h5>
      <div className="ps-3">
        <p className="card-text">
          Hippo Splash is a 3-reel, 3-row (3x3) cascading line slot game, featuring respins and x10 multiplier! 
        </p>
      </div>
      <br />

      <h5 className="card-title">Steps</h5>
      <div className="ps-3">
        <p className="card-text">
          1) Set the preferred betting amount.
        </p>
        <p className="card-text">
          2) Spin the reel.
        </p>
        <p className="card-text">
          3) Once the reel stops, any combinations of according to the paytable awards their corresponding payout.
        </p>
        <p className="card-text">
          4) These combinations are then destroyed and new symbols will cascade down.
        </p>
        <p className="card-text">
          5) Additional winning combinations will continue to be tallied until no more winning combinations are available.
        </p>
        <p className="card-text">
          6) Bonus feature has a chance to be activated on any spin.
        </p>
        <p className="card-text">
          7) Winnings are calculated and round ends.
        </p>
      </div>
      <br />

      <h5 className="card-title">Bonus Features</h5>
      <br />
      <div className="ps-3">
        <h6 className="card-title">Hippo Splash Feature</h6>
        <p className="card-text">
          During any spin, the Hippo Splash Feature may be randomly triggered while the reels are spinning.
        </p>
        <p className="card-text">
          During the Hippo Splash Feature, a symbol is randomly chosen (excluding Wild symbol), and the reels will consist only the randomly chosen symbol, Wild symbol or blank space.
        </p>
        <p className="card-text">
          After all reels stop spinning, if there is 1 or more additional symbol (either a randomly chosen symbol or a Wild symbol) appearing on the reels, all reels will respin again with the previously appeared symbols staying in their positions.
        </p>
        <p className="card-text">
          After all reels stop spinning, if there is no more additional symbol (either a randomly chosen symbol or a Wild symbol) appearing on the reels, the Hippo Splash feature ends and wins are evaluated.
        </p>
        <br />
        <h6 className="card-title">10x Multiplier</h6>
        <p className="card-text">
          When all symbol in the reels are involved in a win, the win will be multiplied by x10.
        </p>
        <p className="card-text">
          Stand a chance to win up to 2500x of the total bet amount.
        </p>
      </div>
      <br />

      <h5 className="card-title">Payout Table</h5>
      <br />
      <div className="ps-3">
        <h6 className="card-title">Symbol Payout Values</h6>
        <br />
        <table className="w-100">
          <tbody>{payoutElement}</tbody>
        </table>
        <br />
        <p className="card-text">
          Wild symbol substitures for all symbols.
        </p>
        <br />
        <h6 className="card-title">Winning Bet Lines</h6>
        <br />
        <img
          className="overview"
          alt="Winning Bet Lines"
          src="/hp/winlines.png"
        />
        <br />
        <br />
        <p className="card-text">
          Only the highest win per bet line is paid.
        </p>
        <p className="card-text">
          Bet lines win if the winning symnols are in succession from the leftmost reel to the right.
        </p>
        <p className="card-text">
          All wins shown in cash.
        </p>
      </div>
      <br />

      <h5 className="card-title">Auto Bet</h5>
      <div className="ps-3">
        <p className="card-text">
          Choose between a preset number of rounds and bet options
        </p>
        <p className="card-text">
          Auto mode will be cancelled when the player leaves the game window/tab or app
        </p>
      </div>
      <br />
    </>
  );
};
